import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=696d6792&scoped=true"
import script from "./Type.vue?vue&type=script&lang=js"
export * from "./Type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696d6792",
  null
  
)

export default component.exports